import { useEffect, useRef } from 'react'

export const usePrevious = <T = unknown>(value: T) => {
    const ref = useRef<T | null>(null)
    useEffect(() => {
        ref.current = value
    }, [value])
    return ref.current
}
